import { z } from 'zod';
import { IsoDateTime, Uuid } from './common.js';
import { OperationalStatus } from './resources.js';
/** Statut ménage minimal (E-19, FR-RES-05) : vue « Ménage du jour ». */
export const HousekeepingRow = z.object({
    resourceId: Uuid,
    resourceName: z.string(),
    internalRef: z.string().nullable(),
    typeCode: z.string(),
    parentResourceId: Uuid.nullable(),
    operationalStatus: OperationalStatus,
    currentGuestName: z.string().nullable(),
    departureAt: IsoDateTime.nullable(),
    nextArrivalAt: IsoDateTime.nullable(),
    nextGuestName: z.string().nullable(),
    statusChangedAt: IsoDateTime.nullable(),
});
export const HousekeepingQuery = z.object({
    propertyId: Uuid.optional(),
    status: OperationalStatus.optional(),
});
export const UpdateHousekeepingStatusRequest = z.object({
    status: z.enum(['DIRTY', 'CLEANING', 'READY']),
    note: z.string().max(500).optional(),
});
//# sourceMappingURL=housekeeping.js.map